import EditItemFilesDialog from './EditItemFilesDialog'

export * from './EditItemFilesDialog'
export default EditItemFilesDialog
